import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DynamicTitleService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {}

  init(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute | null = this.activatedRoute;
          while (route?.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route): route is ActivatedRoute => !!route && route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        const title = data['title'] ?? 'Alinea | Loup Logistics';
        this.titleService.setTitle(title);
      });
  }
}
